import React from 'react'
import { DiRequirejs } from 'react-icons/di';
import './Card.scss';
const Card = () => {
  return (
 
        
    <div
     className='body'
    >
        <div class="card">

<div class="imgBox">
  <img src={require('../../coffeeflavour/espresso.png')} alt="mouse corsair"
   class="mouse"/>
</div>

<div class="contentBox">
  <h3>Espresso</h3>
  <h2 class="price">61.<small>98</small> €</h2>
  <a href="#" class="buy">Buy Now</a>
</div>

</div>

    </div>
  

  )
}

export default Card